import React from 'react';
import { propTypes } from 'react-bootstrap/esm/Image';
import './box.scss';
const Box = ({ title, text, icon }) => {
	return (
		<div className='box'>
			<div className='box-icon'>
				<img src={icon} alt='' />
			</div>
			<h3>{title}</h3>
			<p>{text}</p>
		</div>
	);
};

export default Box;
